import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { industries } from '../data/mockData';
import { ArrowRight, Check } from 'lucide-react';

const Industries = () => {
  return (
    <section id="industries" className="py-24 bg-[#101F27] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Designed For Places People Escape To
          </h2>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <Card
              key={index}
              className="bg-[#37464F]/50 border-gray-800 hover:border-[#009688]/50 transition-all duration-300 overflow-hidden group flex flex-col"
            >
              {/* Image Side */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#101F27]/80 to-transparent"></div>

                {/* Stats Badge */}
                {industry.stats && (
                  <div className="absolute top-4 right-4 bg-[#009688]/90 backdrop-blur-sm rounded-lg px-4 py-2">
                    <div className="text-2xl font-bold text-white">{industry.stats.metric}</div>
                    <div className="text-xs text-white/80">{industry.stats.label}</div>
                  </div>
                )}
              </div>

              {/* Content Side */}
              <CardContent className="p-8 flex flex-col flex-1">
                <h3 className="text-2xl font-bold text-white mb-4">{industry.title}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{industry.description}</p>

                {/* Use Cases */}
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-[#009688] uppercase mb-3">Key Use Cases:</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {industry.useCases.map((useCase, idx) => (
                      <div key={idx} className="flex items-start">
                        <Check className="w-4 h-4 text-[#009688] mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-gray-300 text-sm">{useCase}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <Button
                  className="bg-gradient-to-r from-[#009688] to-[#005B4F] hover:from-[#005B4F] hover:to-[#009688] text-white shadow-lg shadow-[#009688]/20 self-start mt-auto"
                  onClick={() => {
                    const element = document.getElementById('demo');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  See it Work <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Industries */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Don't see your business here? We'd still love to talk.
          </p>
          <Button
            variant="outline"
            className="border-[#009688] text-[#009688] hover:bg-[#009688]/10"
            onClick={() => {
              const element = document.getElementById('demo');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Discuss Your Use Case
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Industries;
